import SimpleBar from "simplebar";

export default function initializePopup() {
    const popupContentAll = document.querySelectorAll('.pup');
    const shadowBox = document.querySelector('.shadow-box');
    const buttonPopups = document.querySelectorAll('.button--pup');

    const runPopup = function (blockId) {
        if (blockId) {
            let popupContentBox = document.querySelector('.pup.' + blockId);

            if(popupContentBox) {
                showPopup(popupContentBox);
            }
        }
    }

    const showPopup = function (popupContentBox) {
        popupContentBox.classList.add('pup--active');
        shadowBox.classList.add('shadow-box--active');
        new SimpleBar(document.querySelector('.pup--active .pup__inner-container'), {
            autoHide: false
        });
    }

    const hidePopup = function () {
        popupContentAll.forEach(function (i) {
            i.classList.remove('pup--active');
        });
        shadowBox.classList.remove('shadow-box--active');
    }

    buttonPopups.forEach(function (i) {
        i.addEventListener('click', function (e) {
            e.preventDefault();
            runPopup(i.dataset.pupId);
        });
    });

    if (document.querySelector('.shadow-box')) {
        document.querySelector('.shadow-box').addEventListener('click', function (e) {
            e.preventDefault();
            hidePopup();
        });
    }

    document.querySelectorAll('.pup__close').forEach(function (item) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            hidePopup();
        });
    });
}
